import { Button, FormGroup, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { insertAdminData, updateAdminData } from '../../api/admin.api'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'

export const AddAdmin = () => {
  const { config } = useAuth();
  const { fetchAdminsList } = useLists();
  const [ confirmPassword, setConfirmPassword ] = useState("");
  const [ loading, setLoading ] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const [ user_type, setUserType ] = useState("");

  const formik = useFormik({
    initialValues: {
    first_name: location?.state?.data?.first_name,
    last_name: location?.state?.data?.last_name,
    mobile_no: location?.state?.data?.mobile_no,
    email: location?.state?.data?.email,
    user_type: location?.state?.data?.user_type,
    password: ""
    },
    onSubmit: async values => {
      const { first_name, last_name, mobile_no, email, password} = values;
      if ( !first_name || !last_name || !mobile_no || !email ) {
        setResponse({ status: "error", msg: "Please Enter All Values!!"});
        setOpen(true);
        return;
      };
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateAdminData({...values, admin_id: location?.state?.data?.admin_id}, config);
        setResponse(submit);
        setOpen(true);
        fetchAdminsList();
        if(submit.status === "success") {
          navigate("/admins");
        }
      } else {
        if ( !password || !confirmPassword ) {
          setResponse({ status: "error", msg: "Please Enter Password!!"});
          setOpen(true);
          return;
        }
        if (values.password !== confirmPassword) {
          setResponse({ status: "error", msg: "Passwords do not match!!"});
          setOpen(true);
          return;
        }
        const submit = await insertAdminData(values, config);
        setResponse(submit);
        fetchAdminsList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/admins");
        }
      }
    },
  });

  // const handleClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }

  //   setOpen(false);
  // };

  // const handleResponse = (data) => {
  //   setLoading(false);
  //   setMsg(data.msg);
  //   setSeverity(data.status);
  //   setOpen(true);
  //   if (data.status === "success") {
  //     navigate("/customers")
  //   }
  // }

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Admin Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <div className='flex'>
          <FormGroup>
            <InputLabel htmlFor="first_name">First Name:<span className='text-[red]'>** </span></InputLabel>
            <OutlinedInput
              name="first_name"
              placeholder="Enter First Name"
              id="first_name"
              type="text"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              />
          </FormGroup>
          <FormGroup className='ml-2'>
            <InputLabel htmlFor="last_name">Last Name:<span className='text-[red]'>** </span> </InputLabel>
            <OutlinedInput
              name="last_name"
              placeholder="Enter Last Name"
              id="last_name"
              type="text"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              />
          </FormGroup>
        </div><br/>
        <FormGroup>
          <InputLabel htmlFor="mobile_no">Mobile No:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="mobile_no"
            placeholder="Enter Mobile No"
            id="mobile_no"
            type="number"
            value={formik.values.mobile_no}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="email">E-mail:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="email"
            placeholder="Enter E-mail"
            id="email"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
                <FormGroup>
                  <InputLabel id="demo-simple-select-label">
                    User-Type:<span className='text-[red]'>** </span>
                  </InputLabel>
                  <Select
                    id="demo-simple-select"
                    value={formik.values.user_type}
                    name="user_type"
                    style={{ textAlign: "left" }}
                    onChange={formik.handleChange}
                  >
                        <MenuItem value="Super Admin">Super Admin</MenuItem>
                        <MenuItem value="Post Admin">Post Admin</MenuItem>
                        <MenuItem value="Sales Admin">Sales Admin</MenuItem>
                        <MenuItem value="Marketing Admin">Marketing Admin</MenuItem>
                        {/* <MenuItem value="mm">MM(s)</MenuItem> */}
                  </Select>
                </FormGroup><br/>
        {!location?.state?.data ? <>
        <FormGroup>
          <InputLabel htmlFor="password">Password:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="password"
            placeholder="Enter Password"
            id="password"
            type="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <FormGroup>
          <InputLabel htmlFor="confirm-password">Confirm Password:<span className='text-[red]'>** </span> </InputLabel>
          <OutlinedInput
            name="confirm-password"
            placeholder="Enter Confirm Password"
            id="confirm-password"
            type="confirm-password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            />
        </FormGroup></> : null}
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/admins")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};
